import { C_Correspondence_Language } from '../../../graphql/generatedModel.ts';

export const getDefaultCorrespondenceLanguage = (language: string): C_Correspondence_Language => {
  switch (language.slice(0, 2)) {
    case 'en':
      return C_Correspondence_Language.CL1_ENGLISH;
    case 'fr':
      return C_Correspondence_Language.CL3_FRENCH;
    case 'it':
      return C_Correspondence_Language.CL4_ITALIAN;
    default:
      return C_Correspondence_Language.CL2_GERMAN;
  }
};

export const getI18nLangFromCorrespondenceLanguage = (lang: C_Correspondence_Language): string => {
  switch (lang) {
    case C_Correspondence_Language.CL1_ENGLISH:
      return 'en';
    case C_Correspondence_Language.CL3_FRENCH:
      return 'fr';
    case C_Correspondence_Language.CL4_ITALIAN:
      return 'it';
    default:
      return 'de';
  }
};
